import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/arrow_down.svg
 */
const IconArrowDown: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      opacity={0.9}
      d="M11.727 17.989c.082.018.165.03.249.034.085-.004.172-.016.256-.034.082-.013.161-.034.24-.063a1.17 1.17 0 00.237-.14.65.65 0 00.152-.085l10.685-9.386a1.334 1.334 0 10-1.761-2.006l-9.81 8.61-9.799-8.61A1.337 1.337 0 00.412 8.315L11.095 17.7c.047.035.1.064.155.086.073.056.15.103.235.14.078.028.16.049.242.062z"
      fill="currentColor"
    />
  </svg>
);

export default IconArrowDown;
